export enum ItemType {
  Component = 'component',
  Configured = 'configured',
  NonConfigured = 'non-configured',
  NonConfiguredFromCustomer = 'non-configured-from-customer',
  ItemFromBusinessCentral = 'item-from-business-central',
  NonInventory = 'non-inventory',
  Unknown = 'unknown'
}
